const fetchWithTimeout = (url, opts = {}, ms = 8000) => {
    const c = new AbortController();
    const id = setTimeout(() => c.abort(), ms);

    return fetch(url, {...opts, signal: c.signal})
        .finally(() => clearTimeout(id));
};

const sleep = async (ms) => new Promise(resolve => setTimeout(resolve, ms));

// local@domain.tld: dot-separated atoms before the @; after it hostname labels (letters, digits,
// inner hyphens, none empty) and a top-level domain of two or more letters, or a punycode one.
// So "test@./con", "a@b", "a@.com" and "a@b..com" are refused before anything is sent; the
// server's own email rule still has the last word.
const EMAIL_PATTERN = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+([a-z]{2,}|xn--[a-z0-9-]+)$/i;

const validateEmail = (email) => EMAIL_PATTERN.test(String(email || '').trim());

const addLog = (message, extra) => {
    try {
        console.log('[log]', message, extra || '');
    } catch (e) {
    }
}

const urlParam = name => {
    let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
        window.location.href,
    );

    return results == null
        ? ''
        : decodeURIComponent(results[1]).replace(/\+/g, ' ') || '';
};

const nextFrame = () => new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

const waitFor = (fn, interval = 330, timeout = 15000) =>
    new Promise((resolve, reject) => {
        const start = Date.now();
        const check = () => {
            try {
                if (fn()) {
                    console.log('wait for: success');
                    return resolve(true);
                }
            } catch {
            }
            if (Date.now() - start > timeout) {
                console.log('wait for: timeout log');
                return reject(new Error('wait for: timeout: ' + (Date.now() - start)));
            }
            setTimeout(check, interval);
        };
        check();
    });

const PAYMENT_SDK_INIT_RETRY_CONFIG = Object.freeze({
    attempts: 5,
    delayMs: 500,
});

const retryAsync = async (task, options = {}) => {
    const attempts = Number.isInteger(options.attempts) && options.attempts > 0 ? options.attempts : 3;
    const delayMs = Number.isInteger(options.delayMs) && options.delayMs >= 0 ? options.delayMs : 300;
    let lastError = null;

    for (let attempt = 1; attempt <= attempts; attempt++) {
        try {
            return await task(attempt);
        } catch (error) {
            lastError = error;
            if (attempt < attempts) {
                await sleep(delayMs);
            }
        }
    }

    throw lastError || new Error('Retry attempts exhausted');
};

export {
    fetchWithTimeout,
    sleep,
    validateEmail,
    addLog,
    urlParam,
    nextFrame,
    waitFor,
    retryAsync,
    PAYMENT_SDK_INIT_RETRY_CONFIG,
}
